import { __awaiter, __generator } from "tslib";
import { jsdomReactUniDriver } from '@unidriver/jsdom-react';
import { UserPresenceKey } from '.';
import { createUserAvatarDriver } from '../../avatars/user-avatar/driver';
import { popoverDriver } from '../../primitives/popover/driver';
export var createUserPresenceDriver = function (wrapper) {
    var base = wrapper.$("." + UserPresenceKey);
    return {
        activeUserInitials: function () { return createUserAvatarDriver(base).getInitials(); },
        presenceType: function () { return base.$('.type').text(); },
        hasPresenceType: function (type) { return base.$("." + type).exists(); },
        activeAdditionalUsers: function () { return base.$('.additional-users-avatar').text(); },
        additionalUsersList: function () { return __awaiter(void 0, void 0, void 0, function () {
            var additionalUsersPopover;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.$('.presence-avatars').click()];
                    case 1:
                        _a.sent();
                        additionalUsersPopover = popoverDriver(jsdomReactUniDriver(document.body));
                        return [2 /*return*/, additionalUsersPopover.$$('.deprecated-text').text()];
                }
            });
        }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map